import ApiClient from './ApiClient';

class ChatCompletionsAPI extends ApiClient {
    constructor() {
        super('assistents', { accountScoped: true });
    }

    improvePrompt(instructions) {
        return axios.post(`${this.url}/improve_prompt`, { instructions });
    }
}

export default new ChatCompletionsAPI();